import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {accessLevelAction} from "redux/actions";


export default function UpdateAccessLevel({editableDetails, onUpdate}) {

    const [accessname, setAccessname] = useState('');
    const [description, setDescription] = useState('');
    const [updateid, setUpdateid] = useState(0);


    const {customers, userRole} = useSelector(state => ({
        customers: state.customers,
        userRole: state.userRole?.filter(role => role.module === "Customers")
    }));

    const dispatch = useDispatch();
    useEffect(() => {
        setAccessname(editableDetails.access_level_name);
        setDescription(editableDetails.description);
        setUpdateid(editableDetails.id);
    }, [editableDetails]);

    const updateData = () =>{
        dispatch(accessLevelAction.update({ id: updateid, name: accessname, desc: description}));
        setAccessname('');
        setDescription('');
        onUpdate();
    } 

   
    return (
        <div>
            <h2>Update Access Level</h2>
            <form action="/action_page.php">
                <div className="form-group" style={{marginBottom:"15px"}}>
                    <label for="access_level_name">Access Level Name:</label>
                    <input type="text" className="form-control" id="access_level_name" placeholder="Enter Access Level Name" name="access_level_name" onChange={e => setAccessname(e.target.value)} value={accessname}/>
                </div>
                <div className="form-group" style={{marginBottom:"15px"}}>
                    <label for="description">Relationship Description:</label>
                    <input type="text" className="form-control" id="description" placeholder="Enter Relationship Description" name="description" onChange={e => setDescription(e.target.value)} value={description} />
                </div>
                <div className="form-group" style={{marginBottom:"15px",textAlign:"right"}}>
                    <button type="button" className="btn btn-primary" onClick={updateData}>Update</button>
                </div>
            </form>
        </div>
    );
}
